import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function CountBox({totalCount, partialCount, showAll}){

    if (totalCount == null || partialCount == null) {
        return (<div className="count_box__loading-spinner" />);
    }

    if (totalCount == partialCount) {
        // Fix for Formatted message bug : 0 does not get displayed
        if (totalCount == 0) {
            totalCount = "0";
        }
        return (
            <div className="count_box">
                <FormattedMessage
                    id="General_CoreFunctionality_UIText_countBox.showTotal"
                    values={{resultsCount: totalCount}} />
            </div>
        );
    }

    if (!showAll) {
        return (
            <div className="count_box">
                <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart1" /> <span>{partialCount}</span> <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart2" /> <span>{totalCount}</span> <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart3" />
            </div>
        );
    } else {
        return (
            <div className="count_box">
                <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart1" /> <span>{partialCount}</span> <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart2" /> <span>{totalCount}</span> <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showingResultsNumbersPart3" />
                <button
                        type="button"
                        className="button-doc-sm count_box__button"
                        onClick={showAll}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_countBox.showAll" />
                </button>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/reusable/CountBox/CountBox.index.jsx